export default "__VITE_ASSET__b2971651__"